export default {
      id: "max-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgsprite.svg#max",
      toString: function () {
        return this.url;
      }
    }